import { Input, Select } from "antd";

export default (editData = {}) => [
  {
    label: "Нэр",
    name: "name",
    rules: [{ required: true, message: "Нэрийг оруулна уу!" }],
    className: "col-span-12 md:col-span-12 mb-0",
    inputProps: {
      placeholder: "Нэр",
      className: "w-full",
    },
  },
 
];
